import { useMutation, useQueryClient } from "@tanstack/react-query";
import { fetcher } from ".";
import {
  DoctorsResponse,
  GuidesResponse,
  PatientResponse,
  SaveHistoryResponse,
} from "../types/responses";
import { API } from "./api";
import { SaveHistoryRequest } from "../types";

export const fetchDoctors = {
  fetch: async () => {
    const { data } = await fetcher().get<DoctorsResponse>(API.GET.DOCTORS);
    return data.doctors;
  },
  queryKey: ["doctors"],
};

export const fetchGuides = {
  fetch: async () => {
    const { data } = await fetcher().get<GuidesResponse>(API.GET.GUIDES);
    return data.guides;
  },
  queryKey: ["guides"],
};

export const fetchPatientById = {
  fetch: (patientId: string) => async () => {
    const { data } = await fetcher().get<PatientResponse>(
      API.GET.PATIENT_BY_ID(patientId)
    );
    return data.patient;
  },
  queryKey: (patientId: string) => ["patient", patientId],
};

export const patientsQueryKey = ["patients"];

const saveHistory = async (body: SaveHistoryRequest) => {
  const { data } = await fetcher().post<SaveHistoryResponse>(
    API.POST.ADD_HISTORY,
    body
  );
  return data;
};

export const useSaveHistoryMutation = ({
  onSuccess,
  onError,
}: {
  onSuccess?: () => void;
  onError?: () => void;
}) => {
  const queryClient = useQueryClient();

  const { mutate, isPending } = useMutation({
    mutationFn: saveHistory,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["history", variables.patientId],
      });
      queryClient.invalidateQueries({
        queryKey: patientsQueryKey,
      });
      onSuccess?.();
    },
    onError: () => {
      onError?.();
    },
  });

  return { mutate, isPending };
};
